import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addUser } from "../../redux/userSlice";
import { getUserHouseList } from "../../redux/houseSettingsSlice";
import { notification, Form, Input, Select } from "antd";
import { NepaliDatePicker } from "nepali-datepicker-reactjs";
import "nepali-datepicker-reactjs/dist/index.css";
import { ADToBS } from "bikram-sambat-js";
import { useParams } from "react-router-dom";

const AddUser = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { Id } = useParams();
  const { loading, error } = useSelector((state) => state.user);
  const userHouseList = useSelector(
    (state) => state.houseSettings.houseSettings
  );
  const [houseId, setHouseId] = useState("");
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [emergencyContact, setEmergencyContact] = useState("");
  const [media, setMedia] = useState(null);
  const [leaseStartDate, setLeaseStartDate] = useState("");
  const [leaseEndDate, setLeaseEndDate] = useState("");
  const [notes, setNotes] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    dispatch(getUserHouseList());
  }, [dispatch]);

  useEffect(() => {
    try {
      const today = new Date();
      console.log(today);
      const nepaliDate = ADToBS(today);
      setLeaseStartDate(nepaliDate);
    } catch (error) {
      console.error("Error converting AD to BS:", error);
    }
  }, []);

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setMedia(e.target.files[0]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    const dynamicId = Id ? Id : houseId;
    console.log("dy", dynamicId);
    formData.append("house_id", dynamicId);
    formData.append("name", name);
    formData.append("phone_number", phoneNumber);
    formData.append("password", password);
    formData.append("email", email);
    formData.append("emergency_contact", emergencyContact);
    if (media) {
      formData.append("document", media);
    }
    formData.append("start_date", leaseStartDate);
    formData.append("end_date", leaseEndDate);
    formData.append("notes", notes);

    dispatch(addUser(formData))
      .unwrap()
      .then(() => {
        notification.success({
          message: "Success",
          description: "User added successfully",
        });
        navigate("/dashboard/userlist");
      })
      .catch((err) => {
        notification.error({
          message: "Error",
          description: Array.isArray(err?.errors)
            ? err.errors.join(", ") // If it's an array of errors
            : Object.entries(err?.errors || {}) // If it's an object of errors
                .map(([field, messages]) => `${field}: ${messages.join(", ")}`)
                .join("\n"),
        });
      });
  };
  const handleHouseChange = (e) => {
    const selectedHouseId = e.target.value;
    setHouseId(selectedHouseId);
  };

  return (
    <div className="pb-20 mx-6">
      <h3 className="font-bold flex text-[22px]">Add User</h3>
      <div className="bg-gray-300 rounded-lg p-4">
        <div className="py-6 bg-white rounded-lg m-3 p-4">
          <form onSubmit={handleSubmit} className="flex flex-col gap-2">
            {!Id && (
              <div className="flex flex-col gap-2">
                <label className="font-bold text-md">House ID:</label>
                <select
                  className="rounded-md py-3 px-4 border-[2px] border-gray-400"
                  value={houseId}
                  onChange={handleHouseChange}
                  required
                >
                  <option value="">Select House Id</option>
                  {userHouseList?.map((house) => (
                    <option key={house.id} value={house.id}>
                      {house.house_number}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <div>
              <label className="font-bold text-md">Name</label>
              <input
                className="rounded-md py-3 px-4 w-full border-[2px] border-gray-400 mt-2"
                type="text"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="font-bold text-md">Phone Number</label>
              <input
                className="rounded-md py-3 px-4 w-full border-[2px] border-gray-400 mt-2"
                type="tel"
                placeholder="Phone Number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="font-bold text-md">Email</label>
              <input
                className="rounded-md py-3 px-4 w-full border-[2px] border-gray-400 mt-2"
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="font-bold text-md">Password</label>
              <input
                className="rounded-md py-3 px-4 w-full border-[2px] border-gray-400 mt-2"
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="font-bold text-md">
                Emergency Contact (Optional)
              </label>
              <input
                className="rounded-md py-3 px-4 w-full border-[2px] border-gray-400 mt-2"
                type="text"
                placeholder="Emergency Contact"
                value={emergencyContact}
                onChange={(e) => setEmergencyContact(e.target.value)}
              />
            </div>
            <div>
              <label className="font-bold text-md">Documents (Optional)</label>
              <input
                type="file"
                onChange={handleFileChange}
                className="rounded-md py-3 px-4 w-full border-[2px] border-gray-400 mt-2 bg-white"
                accept=".jpg,.jpeg,.png,.pdf"
              />
            </div>
            <div>
              <label className="font-bold text-md">
                Lease Start Date (Optional)
              </label>
              <NepaliDatePicker
                type="date"
                className="custom-date-picker"
                value={leaseStartDate}
                options={{ calenderLocale: "en", valueLocale: "en" }}
                onChange={setLeaseStartDate}
                required
              />
            </div>
            <div>
              <label className="font-bold text-md">Notes (Optional)</label>
              <textarea
                className="rounded-md w-full py-4 px-4 border-[2px] border-gray-400 mt-2"
                placeholder="Additional Notes"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                rows="4"
              />
            </div>
            <div>
              <button
                type="submit"
                className={`bg-[#403F93] text-white flex px-24 py-3 rounded-md mt-6 ${
                  loading ? "opacity-50 cursor-not-allowed" : ""
                }`}
                disabled={loading}
              >
                {loading ? "Adding..." : "Add User"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddUser;
